import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=172c8d98&scoped=true"
import script from "./HelpText.vue?vue&type=script&lang=js"
export * from "./HelpText.vue?vue&type=script&lang=js"
import style0 from "./HelpText.vue?vue&type=style&index=0&id=172c8d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c8d98",
  null
  
)

export default component.exports